import {Observable, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DataService} from '../../services/data.service';
import {Budget} from '../../interfaces';
import {AuthService} from '../../services/auth.service';
import {BudgetListTableService} from '../../services/budget-list-table.service';
import {CommonModule} from '@angular/common';
import {MatCardModule} from '@angular/material/card';
import {MatTabsModule} from '@angular/material/tabs';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {BudgetListFilterComponent} from '../../shared/budget-list-filter/budget-list-filter.component';
import {BudgetListTableComponent} from '../budget-list-table/budget-list-table.component';
import {MergedBudgetListComponent} from '../merged-budget-list/merged-budget-list.component';



@Component({
    selector: 'app-budget-list',
    templateUrl: './budget-list.component.html',
    styleUrls: ['./budget-list.component.css'],
    standalone: true,
    imports: [
        CommonModule,
        MatCardModule,
        MatTabsModule,
        MatIconModule,
        MatTooltipModule,
        BudgetListFilterComponent,
        BudgetListTableComponent,
        MergedBudgetListComponent
    ]
})
export class BudgetListComponent implements OnInit, OnDestroy {

    loading = false;

    public budgets: Budget[] = [];
    slowListElements = 0;
    mergedListElements = 0;
    selectedTab = 0;
    queryParamFilter = false;
    public performingQuickSerch$: Observable<boolean>;
    public performingSlowSearch$: Observable<boolean>;
    private dataSubscription;
    private unsubscribe$ = new Subject();

    constructor(
        private authService: AuthService,
        private dataService: DataService,
        private route: ActivatedRoute,
        private budgetListTableService: BudgetListTableService
    ) {
        this.performingQuickSerch$ = this.budgetListTableService.isLoading$('quick');
        this.performingSlowSearch$ = this.budgetListTableService.isLoading$('slow');
    }


    public ngOnInit() {
        this.route.queryParamMap.pipe(takeUntil(this.unsubscribe$)).subscribe((queryParamMap) => {
            setTimeout(function () {
                window.scrollTo(0, Number(sessionStorage.getItem('budgetListScrollPosition')));
                window.addEventListener('scroll', this.scrollHandler, true);
            }.bind(this), 500);
            this.queryParamFilter = queryParamMap.has('new');
        });
    }

    public ngOnDestroy() {
        window.removeEventListener('scroll', this.scrollHandler, true);
        if (this.dataSubscription) {
            this.dataSubscription.unsubscribe();
        }
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
        console.log('On destroy budgetlist. Freeing memory.');
    }

    private scrollHandler() {
        const doc = document.documentElement;
        const top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

        sessionStorage.setItem('budgetListScrollPosition', top.toFixed(0));

    }
}